(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('read-more')) {
    class ReadMore extends HTMLElement {
      #truncatedHtml = '';

      connectedCallback() {
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('.read-more__toggle');
          if (!toggle || !this.contains(toggle)) return;

          if (this.hasAttribute('expanded')) {
            this.collapse();
          } else {
            this.expand();
          }
        });
      }

      #animateHeight(updateContent) {
        const body = this.querySelector('.read-more__body');
        if (!body) return;

        const startHeight = body.offsetHeight;
        updateContent();
        const endHeight = body.offsetHeight;

        body.style.overflow = 'hidden';
        body.style.height = startHeight + 'px';
        void body.offsetHeight;
        body.style.transition = 'height 0.4s ease';
        body.style.height = endHeight + 'px';

        body.addEventListener('transitionend', () => {
          body.style.height = '';
          body.style.overflow = '';
          body.style.transition = '';
        }, { once: true });
      }

      expand() {
        const body = this.querySelector('.read-more__body');
        const fullTemplate = this.querySelector('.read-more__full');
        const lessToggleTemplate = this.querySelector('.read-more__toggle-less');
        if (!body || !fullTemplate || !lessToggleTemplate) return;

        this.#truncatedHtml = body.innerHTML;

        this.#animateHeight(() => {
          body.innerHTML = fullTemplate.innerHTML;
          body.append(lessToggleTemplate.content.cloneNode(true));
        });

        this.setAttribute('expanded', '');
      }

      collapse() {
        const body = this.querySelector('.read-more__body');
        if (!body || !this.#truncatedHtml) return;

        this.#animateHeight(() => {
          body.innerHTML = this.#truncatedHtml;
        });

        this.removeAttribute('expanded');
      }
    }
    customElements.define('read-more', ReadMore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('read-more-lines')) {
    class ReadMoreLines extends HTMLElement {
      #resizeObserver;

      connectedCallback() {
        const content = this.querySelector('.read-more-lines__content');

        this.#init();

        if (content) {
          this.#resizeObserver = new ResizeObserver(() => this.#init());
          this.#resizeObserver.observe(content);
        }

        this.addEventListener('click', this.#onClick);
        this.addEventListener('keydown', this.#onKeydown);
      }

      disconnectedCallback() {
        this.#resizeObserver?.disconnect();
        this.removeEventListener('click', this.#onClick);
        this.removeEventListener('keydown', this.#onKeydown);
      }

      #onClick = (event) => {
        const toggle = event.target.closest('.read-more-lines__toggle');
        if (!toggle || !this.contains(toggle)) return;

        if (toggle.dataset.action === 'expand') {
          this.#expand();
        } else {
          this.#collapse();
        }
      };

      #onKeydown = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const toggle = event.target.closest('.read-more-lines__toggle');
        if (!toggle || !this.contains(toggle)) return;

        event.preventDefault();
        toggle.click();
      };

      #getLineLimit() {
        return parseInt(this.dataset.lineLimit || '2', 10);
      }

      #getLineHeight(element) {
        const style = window.getComputedStyle(element);
        let lineHeight = parseFloat(style.lineHeight);

        if (!Number.isFinite(lineHeight)) {
          lineHeight = parseFloat(style.fontSize) * 1.2;
        }

        return lineHeight;
      }

      #exceedsLineLimit(content) {
        const lineHeight = this.#getLineHeight(content);
        const limit = this.#getLineLimit();
        return content.scrollHeight > lineHeight * limit + 2;
      }

      #setCollapsedHeight(content) {
        const lineHeight = this.#getLineHeight(content);
        content.style.maxHeight = `${lineHeight * this.#getLineLimit()}px`;
        content.style.overflow = 'hidden';
      }

      #clearCollapsedHeight(content) {
        content.style.maxHeight = '';
        content.style.overflow = '';
      }

      #getToggleTarget(content) {
        const paragraphs = content.querySelectorAll('p');
        return paragraphs.length ? paragraphs[paragraphs.length - 1] : content;
      }

      #ensureToggleSibling(toggle, content, afterElement) {
        if (!toggle || !content) return;

        toggle.remove();

        if (afterElement) {
          afterElement.after(toggle);
        } else {
          content.after(toggle);
        }
      }

      #placeToggleInContent(toggle, content) {
        if (!toggle || !content) return;

        toggle.remove();
        const target = this.#getToggleTarget(content);
        target.append(document.createTextNode(' '));
        target.append(toggle);
      }

      #resetTogglesToSibling(content) {
        const expandToggle = this.querySelector('[data-action="expand"]');
        const collapseToggle = this.querySelector('[data-action="collapse"]');

        this.#ensureToggleSibling(expandToggle, content);
        this.#ensureToggleSibling(collapseToggle, content, expandToggle);
      }

      #init() {
        const content = this.querySelector('.read-more-lines__content');
        const expandToggle = this.querySelector('[data-action="expand"]');
        const collapseToggle = this.querySelector('[data-action="collapse"]');

        if (!content || !expandToggle || !collapseToggle) return;

        if (this.hasAttribute('expanded')) {
          this.#resetTogglesToSibling(content);
          this.#clearCollapsedHeight(content);
          this.#placeToggleInContent(collapseToggle, content);
          this.classList.add('is-expanded');
          this.classList.remove('is-collapsed');
          expandToggle.hidden = true;
          collapseToggle.hidden = false;
          return;
        }

        this.#resetTogglesToSibling(content);
        this.#clearCollapsedHeight(content);
        const exceeds = this.#exceedsLineLimit(content);

        if (!exceeds) {
          this.classList.remove('is-collapsed', 'is-expanded');
          expandToggle.hidden = true;
          collapseToggle.hidden = true;
          return;
        }

        this.classList.add('is-collapsed');
        this.classList.remove('is-expanded');
        this.#setCollapsedHeight(content);
        expandToggle.hidden = false;
        collapseToggle.hidden = true;
      }

      #expand() {
        const content = this.querySelector('.read-more-lines__content');
        const expandToggle = this.querySelector('[data-action="expand"]');
        const collapseToggle = this.querySelector('[data-action="collapse"]');

        this.#clearCollapsedHeight(content);
        this.classList.add('is-expanded');
        this.classList.remove('is-collapsed');
        this.#resetTogglesToSibling(content);
        this.#placeToggleInContent(collapseToggle, content);
        expandToggle.hidden = true;
        collapseToggle.hidden = false;
        this.setAttribute('expanded', '');
      }

      #collapse() {
        const content = this.querySelector('.read-more-lines__content');
        const expandToggle = this.querySelector('[data-action="expand"]');
        const collapseToggle = this.querySelector('[data-action="collapse"]');

        collapseToggle?.remove();
        this.#setCollapsedHeight(content);
        this.classList.add('is-collapsed');
        this.classList.remove('is-expanded');

        if (expandToggle) content.after(expandToggle);
        if (collapseToggle) expandToggle?.after(collapseToggle);

        expandToggle.hidden = false;
        collapseToggle.hidden = true;
        this.removeAttribute('expanded');
      }
    }

    customElements.define('read-more-lines', ReadMoreLines);
  }

  } catch(e) { console.error(e); }
})();
})();
